(function (module) {
    'use strict';

    function TutorialsConfig($stateProvider) {

        // Route
        $stateProvider
            .state('root.tutorials', {
                url: '/tutorials',
                abstract: true,

            });
        $stateProvider

            .state('root.tutorials.view', {
                url: '/:type',
                data: {
                    pageTitle: 'Tutorials'
                },
                params: {
                    type: {
                        value: 'welcome',
                        squash: false,
                    }
                },

                views: {
                    'content@root': {
                        templateUrl: '/js/tutorials/tutorials.html',
                        controller: 'TutorialsCtrl as $ctrl'
                    }
                },
                bodyClass: 'page--tutorials'
            });

        // Translations
        // $translatePartialLoaderProvider.addPart('/js/authentication/conditions');

    }

    function TutorialsCtrl($stateParams, $state) {

        this.$onInit = () => {
            this.tutorial = $stateParams.type;

            //hide sidenav & toolbar

            const menuNav = document.getElementById('vertical-navigation');
            const toolbar = document.getElementById('toolbar');
            menuNav.style.display = 'none';
            toolbar.style.display = 'none';

        };

        this.goToManager = () => {

            //show sidenav & toolbar

            const menuNav = document.getElementById('vertical-navigation');
            const toolbar = document.getElementById('toolbar');
            menuNav.style.display = 'inline-block';
            toolbar.style.display = 'inline-block';
        };

    }

    module
        .config(TutorialsConfig)
        .controller('TutorialsCtrl', TutorialsCtrl);

})(angular.module('rocket.components'));
